// ESM-Huelle fuer lib/scripts/components/CMP_CLabeledInputField2.js (ESM-Welle 5b).
// Originalquelltext unveraendert uebernommen; nur Import/Export sind neu.
// Prototype-Stil bleibt - class-Migration ist ein separater Schritt.
import { CComponent } from './component.js';

function CLabeledInputField2 (id)
{
    this.construct (id);
    
    this.htmlType = "span";
    
    this.properties =
    {
        backspace:
        {
            show: true,
            caption: {},
            styles:
            {
                width: "35px",
                height: "35px",
                marginLeft: "5px",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "middle",
                backgroundPosition: "3px 4px",
                backgroundImage: "url(lib/img/backspace.png)"
            }
        },
        clear:
        {
            show: true,
            caption: {},
            styles:
            {
                width: "35px",
                height: "35px",
                marginLeft: "5px",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "4px 4px",
                backgroundImage: "url(lib/img/clear.png)"
            }
        },
        input:
        {
            type: "all",
            styles:
            {
                fontWeight: "bold",
                fontSize: "12px",
                padding: "0px",
                margin: "0px"
            }
        },
        label:
        {
            value: "Generische Anzeige",
            styles:
            {
                fontWeight: "bold",
                fontSize: "12px",
                padding: "0px",
                margin: "0px"
            }  
        },
        container:
        {
            rows: 1,
            columns: 1,
            styles:
            {
                width: "auto",
                height: "auto"
            }
        },
        inputcontainer:
        {
            rows: 2,
            columns: 1,
            styles:
            {
                marginLeft: "5px"
            }
        }               
    }
    
    this.container = null;
    this.input = null;
    this.label = null;
    this.inputcontainer = null;
    this.backspace = null;
    this.clear = null;
}

CLabeledInputField2.prototype = new CComponent;

CLabeledInputField2.prototype.prepare = function ()
{    
    this.container = this.addChild (CContainerTable);
    this.container.properties = combine (this.container.properties, this.properties.container);
    
    var buttons = 0;
    
    if (this.properties.backspace.show)
    {
        buttons++;
        this.container.properties.columns++;
    }
    if (this.properties.clear.show)
    {
        buttons++;
        this.container.properties.columns++;
    }
    
    this.container.prepare ();

    this.inputcontainer = this.container.body.rows[0].columns[0].addChild (CContainerTable);
    this.inputcontainer.properties = combine (this.inputcontainer.properties, this.properties.inputcontainer);
    this.inputcontainer.prepare();
     
    this.inputcontainer.body.rows[0].columns[0].properties.styles.textAlign = "left";
    this.inputcontainer.body.rows[1].columns[0].properties.styles.textAlign = "left";

    this.label = this.inputcontainer.body.rows[0].columns[0].addChild (CCaption);
    this.label.properties = combine (this.label.properties, this.properties.label);
    this.label.properties.styles.position = "static";
    /*this.label.properties.styles.width = this.inputcontainer.properties.styles.width;
    this.label.properties.styles.height = (height / 2) + "px";*/
    
    this.label.prepare();

    this.input = this.inputcontainer.body.rows[1].columns[0].addChild (CInput);
    this.input.properties = combine (this.input.properties, this.properties.input);
    this.input.properties.styles.position = "static";
    /*this.input.properties.styles.width = this.inputcontainer.properties.styles.width;
    this.input.properties.styles.height = (height / 2) + "px";*/

    var col = 1;

    if (this.properties.backspace.show)
    {
        this.backspace = this.container.body.rows[0].columns[col].addChild (CPushButton);
        this.backspace.properties = combine (this.backspace.properties, this.properties.backspace);
        this.backspace.properties.events.onClick = this.gotBackspace;
        this.backspace.properties.attributes.onClick_parameter_0 = this.input.id;
        col++;
    }
    
    if (this.properties.clear.show)
    {
        this.clear = this.container.body.rows[0].columns[col].addChild (CPushButton);
        this.clear.properties = combine (this.clear.properties, this.properties.clear);
        this.clear.properties.events.onClick = this.gotClear;
        this.clear.properties.attributes.onClick_parameter_0 = this.input.id;
        col++;
    }
    
    this.prepared = true;
}

CLabeledInputField2.prototype.gotBackspace = function (component, parameters)
{
    var comp = POS.getComponentById(parameters[0]);
    comp.gotBackspace ();
}


CLabeledInputField2.prototype.gotClear = function (component, parameters)
{
    var comp = POS.getComponentById(parameters[0]);
    comp.gotClear ();
}

CLabeledInputField2.prototype.setEnabled = function(bool)
{
    this.label.setEnabled(bool);
    this.field.setEnabled(bool);
}
export { CLabeledInputField2 };
